var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1464 10.4054C10.0527 10.4992 10 10.6264 10 10.759L10.0001 13.5132C10.0001 13.7893 10.224 14.0132 10.5001 14.0132L13.2542 14.0132C13.3868 14.0132 13.514 13.9605 13.6078 13.8667L20.3094 7.16513C21.2652 6.20931 21.2652 4.65962 20.3094 3.7038C19.3536 2.74798 17.8039 2.74798 16.848 3.7038L10.1464 10.4054ZM11.0001 13.0132L11 10.9661L17.5552 4.41091C18.1204 3.84561 19.037 3.84561 19.6023 4.41091C20.1676 4.9762 20.1676 5.89273 19.6023 6.45802L13.0471 13.0132H11.0001ZM4 7.50005C4 6.67162 4.67157 6.00005 5.5 6.00005H12.5C12.7761 6.00005 13 5.77619 13 5.50005C13 5.2239 12.7761 5.00005 12.5 5.00005H5.5C4.11929 5.00005 3 6.11933 3 7.50005V18.5C3 19.8808 4.11929 21 5.5 21H16.5C17.8807 21 19 19.8808 19 18.5V12.5C19 12.2239 18.7761 12 18.5 12C18.2239 12 18 12.2239 18 12.5V18.5C18 19.3285 17.3284 20 16.5 20H5.5C4.67157 20 4 19.3285 4 18.5V7.50005Z",
    fill: "#6D6970"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.6d6c6f383fff222536c9b23ebc8f27c5.svg";
export { ForwardRef as ReactComponent };